import { FunctionComponent } from 'react';
import Button from './Button';

export type AdminActionProps = {
  className?: string;
  text: string;
  onClick: (evt: React.MouseEvent) => void;
};

const AdminAction: FunctionComponent<AdminActionProps> = ({
  className,
  text,
  onClick,
}) => {
  return (
    <Button className={className} onClick={onClick}>
      {text}
    </Button>
  );
};

AdminAction.displayName = 'AdminAction';

export default AdminAction;
